import React from "react";
import ResponsivePlayer2 from '../video/responsive-Player2';
import "../../css/font-awesome.min.css";
import "../../css/elegant-font-icons.css";
import "../../css/elegant-line-icons.css";
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/venobox/venobox.css";
import "../../css/owl.carousel.css";
import "../../css/main.css";
import "../../css/responsive.css";
import { Helmet } from "react-helmet";
import darkLogo from "../../img/logo-dark.png";
import clueCap from "../../img/newCClogo.png";
import product1 from "../../img/product-1.png";
import ccTimeline from '../../img/ccTimeline.png';
import "./story.css";
import { withRouter } from 'react-router-dom';
import ReactPlayer from 'react-player'
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import ReactGA from 'react-ga'

ReactGA.initialize('UA-218915160-1')
ReactGA.pageview("/story")
class Story extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false
		}
		this.openModal = this.openModal.bind(this)
		this.closeModal = this.closeModal.bind(this)
	}
	openModal() {
		this.setState({ isOpen: true })
		console.log(this.state.isOpen)
	}

	closeModal() {
		this.setState({ isOpen: false })
		console.log(this.state.isOpen)
	}
	componentDidMount() {

	}
	render() {

		var jsm = {
			marginLeft: "0%",
			marginTop:"3%"
		}
		var prot1 = "https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1640626504/20210815_155936_jhcje0.jpg"
		var prot2 = "https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1640626582/20210815_155850_jfygbv.jpg"
		var prot3 = "https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1640626333/Clue_Cap_hyge0t.jpg"
		var pogo1 = "https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1640631999/Mora_V1_Rendering_6_lftec0.png"
		var pcb1 = "https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1640626665/20210718_191529_swkhvb.jpg"
		var pcb2 = "https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1640626662/20210719_114601_lwgjxn.jpg"
		var pcb3 = "https://res.cloudinary.com/logic-pill/image/upload/c_scale,h_240,w_320/v1640626616/20210722_183758_jeegof.jpg"
		var im ="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1640366974/small_tj9arr.png"
		return (
			<React.Fragment>	
				<section>
					<div className="container">
						<div className="section_heading align-center mb-40">
							<br></br>
							<br></br>
							<br></br>
							<br></br>
							<h2>The Origin Story</h2>
							<p>Whenever I wanted to smoke a cigar, I hated not having an ashtray around. That meant I had to get up and find a trash can because whenever I cut a cigar the cap and some tobacco would go flying around. So, I invented the Turtle Cutter to catch the cut cigar cap.</p>
						</div>
					</div>
				</section>
				<section className="">
					<div className="container">
						<div className="promo_items">
							<div className="col-sm-12 col-xs-12 xs-padding">
								<div className="promo_item wow zoomIn" data-wow-delay="0ms" data-wow-duration="2000ms">
									<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
										<img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_250/v1742766302/Resized_PXL_20241107_211835311-1_166853857051192001_kvjhrb.jpg" alt="Stock"></img>
										<h3>What is it?</h3>
										<p>There were cutters that existed that stored the cap after a cut, but they were not designed for that specific purpose. I also wanted to store the ashes from smoking a cigar if there was not an ashtray nearby. So, I set out to create one.</p>
									</div>
								</div>
							</div>

						</div>
					</div>
				</section>
				<section className="">
					<div className="container">
						<div className="promo_items">
							<div className="col-sm-12 col-xs-12 xs-padding">
								<div className="promo_item wow zoomIn" data-wow-delay="0ms" data-wow-duration="2000ms">
									<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
										<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
											{!isMobile ? <img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_533/v1742766302/Resized_20241118_145512_547205602301307_qavxqh.jpg" alt="Stock"></img> :
												<img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_240/v1742766302/Resized_20241118_145512_547205602301307_qavxqh.jpg" alt="Stock"></img>}
											<h3>How the idea came about.</h3>
											<p>
                                                I was sick of cutting a cigar and having to pick up the fallen cap after I cut any. I just wanted to cut and start smoking and not worry about the clean-up.
									      </p>
											
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</section>
				<section className="">
					<div className="container">
						<div className="promo_items">
							<div className="col-sm-12 col-xs-12 xs-padding">
								<div className="promo_item wow zoomIn" data-wow-delay="0ms" data-wow-duration="2000ms">
									<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
										<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
											<div className="why_list wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="2000ms">

												<h3>The first prototypes:</h3>
												<p>The first prototypes I made were from a 3D printer, tape, and some crazy glue. I went and had a professional do it for a working prototype</p>
												<img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_239/v1742766301/Resized_20241118_175624_547196190279800_exyduu.jpg" alt="Stock" style={jsm}></img>
												<br></br><br></br>
												<p>Once I had a working prototype, it was time to paint it. Lots of primer and acetone.</p>
											
												<img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_247/v1742766301/Resized_20241119_192300_497232824149172_jqoyp2.jpg" style={jsm} alt="Stock"  ></img>
												<br></br>	<br></br>
												<p>Then I created the logo to put on the cutter.</p><br></br>

												<p>
											
									</p>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</section>
				
				<section className="">
					<div className="container">
						<div className="promo_items">
							<div className="col-sm-12 col-xs-12 xs-padding">
								<div className="promo_item wow zoomIn" data-wow-delay="0ms" data-wow-duration="2000ms">
									<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
										<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
											<div className="why_list wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="2000ms">
												<div className="why_list wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="2000ms">
												{!isMobile ? <img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_491/v1742740513/jared5-ezgif.com-video-to-gif-converter_lmvsoz.gif" alt="Stock"></img> :
												<img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_253/v1742740513/jared5-ezgif.com-video-to-gif-converter_lmvsoz.gif" alt="Stock"></img>}
													<h3>Thank you</h3>
													<p>I want to thank all of you for reading and for the support. If you think the Turtle Cutter will help you, please purchase one! After our Kickstarter, we plan to sell on Amazon and continue to improve the product.</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</section>


			</React.Fragment>
		);
	}
}

export default withRouter(Story);